import { AuthGuard } from 'app/shared/auth/auth-guard.service';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";

import { Full_ROUTES } from "./shared/routes/full-layout.routes";
import { CONTENT_ROUTES } from "./shared/routes/content-layout.routes";

// import { AuthGuard } from './shared/auth/auth-guard.service';

const appRoutes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'pages/login',
  //   pathMatch: 'full',
  // },
  // { path: '', redirectTo: 'form', pathMatch: 'prefix' },
  // { path: 'form', loadChildren: () => import('./page/page.module').then(m => m.PageModule)},

  // { path: '', component: FullLayoutComponent, data: { title: 'full Views' }, children: Full_ROUTES  },

  {
    path: '',
    redirectTo: 'Select',
    pathMatch: 'full',
  },
  // { path: '', component: FullLayoutComponent, data: { title: 'full Views' }, children: Full_ROUTES },
  // { path: '', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES },
 { path: 'Select', loadChildren: () => import('./selectproduct/selectproduct.module').then(m => m.SelectproductModule) },

{ path: 'Merchant', loadChildren: () => import('./page1/page.module').then(m => m.PageModule) },
{ path: 'Aabha-Login', loadChildren: () => import('./abha/abha.module').then(m => m.AbhaModule) },
{ path: 'Tatkaal-Payment', loadChildren: () => import('./worldLine/worldline.module').then(m => m.WorldlineModule) },

//  { path: ':product', component: FullLayoutComponent, data: { title: 'full Views' }, children: Full_ROUTES },
  // { path: 'Invoice', component: FullLayoutComponent, data: { title: 'full Views' },
  // children: [
  //   { path: '', loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule) ,canActivate:[AuthGuard],canLoad:[AuthGuard] }
    
  // ],canActivate:[AuthGuard],canLoad:[AuthGuard] },

  // { path: 'Supplier', component: FullLayoutComponent, data: { title: 'full Views' },
  //  children: [
  //   { path: '', loadChildren: () => import('./supplier/supplier.module').then(m => m.SupplierModule),canActivate:[AuthGuard],canLoad:[AuthGuard]  },
  // ],canActivate:[AuthGuard],canLoad:[AuthGuard] },

   { path: 'Admin', component: FullLayoutComponent, data: { title: 'full Views' },
    children: [
     { path: '', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),canActivate:[AuthGuard],canLoad:[AuthGuard] },
   ],canActivate:[AuthGuard],canLoad:[AuthGuard] },

   //Path For Distributor Module Start
   { path: 'Distributor', component: FullLayoutComponent, data: { title: 'full Views' },
   children: [
    { path: '', loadChildren: () => import('./distributor/distributor.module').then(m => m.DistributorModule) ,canActivate:[AuthGuard],canLoad:[AuthGuard] },
  ] ,canActivate:[AuthGuard],canLoad:[AuthGuard]},
   //Path For Distributor Module End

  { path: 'Hospital', component: FullLayoutComponent, data: { title: 'full Views' },
   children: [
    { path: '', loadChildren: () => import('./hospital/hospital.module').then(m => m.HospitalModule) ,canActivate:[AuthGuard],canLoad:[AuthGuard] },
  ] ,canActivate:[AuthGuard],canLoad:[AuthGuard]},

  { path: 'Aggregator', component: FullLayoutComponent, data: { title: 'full Views' },
    children: [
     { path: '', loadChildren: () => import('./aggregator/aggregator.module').then(m => m.AggregatorModule),canActivate:[AuthGuard],canLoad:[AuthGuard]},
   ],canActivate:[AuthGuard],canLoad:[AuthGuard] },

   { path: 'Lender', component: FullLayoutComponent, data: { title: 'full Views' },
    children: [
     { path: '', loadChildren: () => import('./lender/lender.module').then(m => m.LenderModule),canActivate:[AuthGuard],canLoad:[AuthGuard]},
   ] ,canActivate:[AuthGuard],canLoad:[AuthGuard]},

   { path: 'Vendor', component: FullLayoutComponent, data: { title: 'full Views' },
  children: [
   { path: '', loadChildren: () => import('./vendor/vendor.module').then(m => m.VendorModule) ,canActivate:[AuthGuard],canLoad:[AuthGuard] },
 ] ,canActivate:[AuthGuard],canLoad:[AuthGuard]},

  {
    path: '**',
    redirectTo: 'pages/error'
  }
];




@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
